import dayjs, { Dayjs } from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(localizedFormat);
dayjs.extend(utc);

export const toDayjs = (date: string): Dayjs => dayjs(date);

/**
 * Formats a date string as a full date
 * Format: MMMM D, YYYY
 * Example: August 16, 2018
 */
export const formatAsFullDate = (utcDateString: string): string => dayjs.utc(utcDateString).format('LL');

/**
 * Formats a date string as a full date with the month abbreviated
 * Format: MMM D, YYYY
 * Example: Aug 16, 2018
 */
export const formatAsFullDateAbbrMonth = (utcDateString: string): string => dayjs.utc(utcDateString).format('ll');

/**
 * Formats a date object as a date string in ISO8601 format
 */
export const formatAsDateString = (date: Dayjs): string => dayjs.utc(date).format();

/**
 * Sorts two date strings in a way that is compatible with Array.sort.
 */
export const sortDates = (date1: string, date2: string): number => {
  const d1 = dayjs(date1);
  const d2 = dayjs(date2);

  if (d1.isBefore(d2)) {
    return -1;
  }
  if (d1.isAfter(d2)) {
    return 1;
  }
  return 0;
};
